<template lang="pug">
.modal-card
    header.modal-card-head
      p.modal-card-title
        b(v-t="'memberships.details_title'")
      div
        a.button.is-white.is-small(@click="$emit('close')")
          span.icon
            i.mdi.mdi-close.mdi-24px
    section.modal-card-body
        customer-membership-view(:value="value" :open="true")
        template(v-if="membership && membership.expire")
          p.mb-2(v-if="!showExtendExpiration")
            a(@click="showExtendExpiration = true") {{ $t('memberships.extend_expiration') }}
          template(v-else)
            b-field(:label="$t('memberships.expire_heading')")
              localized-datepicker(append-to-body :placeholder="$t('memberships.expiration_description')" icon="calendar" v-model="expiryDate" editable)
          label.label(v-t="'memberships.redemption_history_title'")
          .list(v-if="membership && membership.transactions && membership.transactions.length")
            .list-item.is-flex.is-justify-content-space-between(v-for="transaction in membership.transactions")    
              div(v-if="transaction.sale")
                invoice-view(:value="transaction.sale" :invoice="transaction.invoice")
              div(v-else-if="transaction.appointment")
                span {{ $t('memberships.late_cancelation') }}
              div 
                date-view(:value="transaction.ts" format="L LT")
          p.has-text-grey(v-else v-t="'memberships.not_redeemed_yet'")
          
          hr
        
        b-field(:label="$t('memberships.notes_label')")
          b-input(v-model="notes" type="textarea" :placeholder="$t('memberships.notes_placeholder')")
        
    footer.modal-card-foot
      .buttons
        action-button(title="actions.update" @click="update" :loading="submitting")
        button.button(@click="$emit('close')") {{$t('actions.close')}}
        
</template>
<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'MembershipDetails',
  props: {
    value: {type: String, required: true}
  },
  data() {
    return {
      notes: undefined,
      submitting: false,
      showExtendExpiration: false,
      expiryDate: undefined
    }
  },
  computed: {
    ...mapState('memberships', ['membershipsMap']),
    membership() {
      return this.membershipsMap[this.value]
    }
  },
  async created() {
    await this.getMembershipById(this.value)
    this.expiryDate = this.membership.expire
    this.notes = this.membership.notes
  },
  methods: {
    ...mapActions('memberships', ['updateMembership', 'getMembershipById']),
    async update() {
      if (this.submitting) {
        return
      }
      this.submitting = true
      try {
        await this.updateMembership({
          id: this.membership._id,
          data: {
            notes: this.notes,
            expire: this.showExtendExpiration ? this.expiryDate : undefined
          }
        })

        this.$buefy.toast.open({
          message: this.$t('status.save_success'),
          queue: false,
          type: 'is-success',
          position: 'is-top'
        })
        this.$emit('update', this.membership)
        this.$emit('close')
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.submitting = false
    }
  }
}
</script>
